export interface IPaginatorResourceStrings {
    igx_paginator_label?: string;
}

export const PaginatorResourceStringsEN: IPaginatorResourceStrings = {
    igx_paginator_label: 'Items per page'
};
